// M8.1 Plans V2 — flag parser.
//
// Env var: VITE_PLANS_V2_ENABLED. Default OFF.
// Parser strictly `=== 'true'` per 2026-10-30 M7/M8 amendment §4.8
// per-surface flag contract. Anything else (undefined, 'false',
// 'TRUE', '1', 'yes', '') is treated as OFF — the strict comparison
// is the hard contract so a misconfigured env can't accidentally
// expose the agent-primary plans surface in production.
//
// Flag OFF: App.tsx does not register `/v2/plans/*`. Legacy
//           `/plans/:planId` and `/plans/:planId/performance` stay
//           mounted.
// Flag ON:  one `/v2/plans/*` route renders the list, detail, thread,
//           and draft children inside PlansV2Page. Legacy routes stay
//           mounted. Removal is a later cleanup.

export function isPlansV2Enabled(): boolean {
  return import.meta.env.VITE_PLANS_V2_ENABLED === 'true';
}
